module.exports = __webpack_public_path__ + "images/logo-blue_0f6a1719c6edc48dbf238e26a3130a56.png";